import Lookup from './lookup.js';

export default class Permission extends Lookup
{
    
}
